import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import rightImg from "images/AbourUsImage.webp";
import { FC } from "react";
import { Helmet } from "react-helmet-async";
import SectionFounder from "./SectionFounder";
import SectionHero from "./SectionHero";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        {/* TITLE */}
        <title>
          About Devi Plastic | Sink Coupling Manufacturer in Ahmedabad, Gujarat
        </title>

        {/* META DESCRIPTION */}
        <meta
          name="description"
          content="Devi Plastic is a trusted sink coupling and drainage fittings manufacturer based in Ahmedabad, Gujarat. With years of experience in precision plastic molding, we deliver durable, high-quality products across India."
        />

        {/* KEYWORDS */}
        <meta
          name="keywords"
          content="about Devi Plastic, sink coupling manufacturer, plastic sink coupling manufacturer, drainage fittings manufacturer, Ahmedabad plastic manufacturer, Gujarat sink coupling company, kitchen sink coupling manufacturer, bathroom drainage fittings, Indian plastic manufacturer"
        />

        {/* CANONICAL */}
        <link rel="canonical" href="https://www.deviplastic.in/about" />

        {/* OPEN GRAPH */}
        <meta
          property="og:title"
          content="About Devi Plastic | Trusted Sink Coupling Manufacturer"
        />
        <meta
          property="og:description"
          content="Learn about Devi Plastic – a leading manufacturer of premium sink couplings and drainage fittings from Ahmedabad, Gujarat."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.deviplastic.in/about" />
        <meta
          property="og:image"
          content="https://www.deviplastic.in/og-about.jpg"
        />

        {/* TWITTER */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Devi Plastic | Sink Coupling Manufacturer"
        />
        <meta
          name="twitter:description"
          content="Trusted manufacturer of sink couplings & drainage fittings with years of experience in plastic molding."
        />

        {/* STRUCTURED DATA – ORGANIZATION / MANUFACTURER */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Devi Plastic",
            url: "https://www.deviplastic.in",
            logo: "https://www.deviplastic.in/logo.png",
            description:
              "Devi Plastic is a trusted manufacturer of high-quality sink couplings and drainage fittings based in Ahmedabad, Gujarat.",
            foundingLocation: {
              "@type": "Place",
              address: {
                "@type": "PostalAddress",
                addressLocality: "Ahmedabad",
                addressRegion: "Gujarat",
                addressCountry: "IN",
              },
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "111/A, Vijay Industrial Estate, Near Bhikshuk Gruh, Odhav",
              addressLocality: "Ahmedabad",
              addressRegion: "Gujarat",
              postalCode: "382415",
              addressCountry: "IN",
            },
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-9924823363",
              contactType: "customer service",
              areaServed: "IN",
              availableLanguage: ["English", "Gujarati"],
            },
          })}
        </script>
      </Helmet>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />
      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <SectionHero
          rightImg={rightImg}
          heading="👋 About Us"
          btnText=""
          subHeading="Devi Plastic is a trusted manufacturer of high-quality sink couplings and drainage fittings. Based in Ahmedabad, Gujarat, we specialize in precision plastic molding and durable designs that ensure long-lasting performance. With years of industry experience, we are committed to delivering reliable products, consistent quality, and complete customer satisfaction across India."
        />

        <SectionFounder />
        {/* <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay />
        </div> */}
      </div>
    </div>
  );
};

export default PageAbout;
